import { memo } from "react";
import styled, { css } from "styled-components";
import { dividerColor } from "../../../helpers/color";
const Divider = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "Divider",
  componentId: "sc-153rwm7-0"
})(["background-color:", ";", ""], dividerColor, ({
  vertical
}) => vertical ? css(["width:2px;"]) : css(["height:2px;"])));
Divider.displayName = "Divider";
export default Divider;
//# sourceMappingURL=index.js.map